import Request from './request';

// The cart API returns { success: true, data: ... } instead of the standard
// { status: 1, data: ... } contract. Normalize so the asyncActionCreator
// middleware treats a successful response correctly.
const normalizeCartResponse = res => ({
  ...res,
  status: res && res.success ? 1 : 0,
});

export const apiAddOrderToCart = (companyId, data) =>
  Request.call({
    url: `/company/${companyId}/cart/add-order`,
    method: 'POST',
    data,
  }).then(normalizeCartResponse);

export const apiGetCartDetails = (companyId, cartId) =>
  Request.call({
    url: `/company/${companyId}/cart/${cartId}`,
    method: 'GET',
  }).then(normalizeCartResponse);

export const apiRemoveCartItem = (companyId, itemId) =>
  Request.call({
    url: `/company/${companyId}/cart/items/${itemId}`,
    method: 'DELETE',
  }).then(normalizeCartResponse);

export const apiCartCheckout = (companyId, data) =>
  Request.call({
    url: `/company/${companyId}/cart/checkout`,
    method: 'POST',
    data,
  }).then(normalizeCartResponse);
